export default __webpack_public_path__ + "static/media/Chhatt_fina_m.78c4b75b.wav";